import React from 'react';

import { LogOut, Undo, UserRound } from 'lucide-react'; // Importing Lucide React's LogOut icon
import { useNavigate } from 'react-router-dom';

import { useSessionActions } from '../../hooks/useSessionActions';
import { getRoles } from '../../utils/tokenUtils';

const ProfileMenu: React.FC = () => {
  const navigate = useNavigate();
  const { adminId, logOut, returnToAdmin } = useSessionActions();
  // Only a member has a profile page. An admin who is also a member has both roles.
  const isMember = getRoles()?.includes('User') ?? false;

  return (
    <div className="absolute right-0 z-50 mt-2 w-52 overflow-hidden rounded-lg border border-gray-200 bg-white py-2 shadow-xl">
      {adminId && (
        <button
          className="flex w-full items-center gap-2 px-4 py-2 text-left text-sm text-ink transition-colors hover:bg-primary/10 focus:outline-none"
          onClick={() => void returnToAdmin()}
          aria-label="Return to admin"
        >
          <Undo className="h-4 w-4 text-primary-deep" />
          <span>Return to Admin</span>
        </button>
      )}
      {isMember && (
        <button
          className="flex w-full items-center gap-2 px-4 py-2 text-left text-sm text-ink transition-colors hover:bg-primary/10 focus:outline-none"
          onClick={() => navigate('/member/profile')}
          aria-label="My profile"
        >
          <UserRound className="h-4 w-4 text-primary-deep" />
          <span>My Profile</span>
        </button>
      )}
      <button
        className="flex w-full items-center gap-2 px-4 py-2 text-left text-sm text-ink transition-colors hover:bg-primary/10 focus:outline-none"
        onClick={logOut}
        aria-label="Log out"
      >
        <LogOut className="h-4 w-4 text-primary-deep" />
        <span>Log Out</span>
      </button>
    </div>
  );
};

export default ProfileMenu;
